import React from 'react';
import Photo from '../Photo'
import VideoLoop from '../VideoLoop'
import styled from 'styled-components'
const ImagesThreeUpWrapper = styled.div`
    .image-3-grid {
        display: grid;
        grid-template-columns: [image-1] 4fr [image-2] 4fr [image-3] 4fr;
        column-gap: 1rem;
    }
    .image-3-1 {
        grid-area: image-1;
    }
    .image-3-2 {
        grid-area: image-2;
    }
    .image-3-3 {
        grid-area: image-3;
    }
`

const ImagesThreeUp = ({
    localFile1, 
    localFile1URL, 
    localFile1Ext, 
    altText1, 
    localFile2,
    localFile2URL, 
    localFile2Ext,  
    altText2, 
    localFile3, 
    localFile3URL, 
    localFile3Ext, 
    altText3,
    vid1,
    vid2,
    vid3,
    vid1AltText,
    vid2AltText,
    vid3AltText
    }) => {
  return  (
  <ImagesThreeUpWrapper className="row-component">

      <div class="image-3-grid">
            
            
            <div className="image-3-1">
                {vid1 &&
                    <VideoLoop src={vid1} description={vid1AltText} />
                }
                {localFile1 &&      
                    <Photo localFile={localFile1} altText={altText1} />
                }
                {/* {(localFile1Ext && localFile1Ext === 'gif') &&
                    <AnimatedGif src={localFile1URL} altText={altText1} /> */
                }
            </div>
            
      
            <div className="image-3-2">
                {vid2 &&
                    <VideoLoop src={vid2} description={vid2AltText} />
                }
                {localFile2 && 
                    <Photo localFile={localFile2} altText={altText2} />
                }
                {/*(localFile2Ext && localFile2Ext === 'gif') &&
                    <AnimatedGif src={localFile2URL} altText={altText2} />
                */}
            </div>
    
      
            <div className="image-3-3">
                {vid3 &&
                    <VideoLoop src={vid3} description={vid3AltText} />
                }
                {localFile3 && 
                    <Photo localFile={localFile3} altText={altText3} />
                }
                {/* {(localFile3Ext && localFile3Ext === 'gif') &&
                    <AnimatedGif src={localFile3URL} altText={altText3} /> */
                }
            </div>
            
      </div>

  </ImagesThreeUpWrapper>
  )
};

export default ImagesThreeUp;
